import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';
import { isStandalone } from '@/utils/platform/isStandalone';

const readBrowserParam = (key: string): string | undefined => {
  return new URLSearchParams(window.location.search).get(key) ?? undefined;
};

const extractUrlParams = (
  keys: DeeplinkKeys[]
): Partial<Record<DeeplinkKeys, string>> => {
  const params = getContext().general.location.getState().params ?? {};

  return keys.reduce<Partial<Record<DeeplinkKeys, string>>>((acc, key) => {
    const sdkValue = params[key];

    const value = isStandalone() ? readBrowserParam(key) : sdkValue;

    return value ? { ...acc, [key]: value } : acc;
  }, {});
};

export default extractUrlParams;
